<script>
  import { onDestroy } from 'svelte';
  import {
    fetchLivePosts,
    getLatestTimeStamp,
    getRecentPosts
  } from '../../api/Scribble/query';
  import FeedItem from './FeedItem/FeedItem.svelte';
  import Icon from '../Icons/Icon.svelte';
  import Spinner from '../Icons/Spinner.svelte';
  export let title = '';
  export let channel;
  let posts;
  let stream;
  let pagination;
  let page = 0;
  let spinner = false;
  let timestamp;

  $: (title || channel) && fetchFirstLiveFeed();

  const interval = setInterval(() => fetchFreshData(), 20000);

  const fetchRecentPosts = async () => {
    const latestPosts = await getRecentPosts(channel, timestamp);
    if (latestPosts && latestPosts.posts && latestPosts.posts.length) {
      latestPosts.posts.map((post) => {
        if (!post.IsDeleted && !posts.find((p) => p.Id === post.Id)) {
          posts = [post, ...posts];
        }
      });
    }
  };

  const fetchFreshData = async () => {
    if (channel) {
      const res = await getLatestTimeStamp(channel);
      if (res && res.Time) {
        if (timestamp !== Number(res.Time)) {
          timestamp = Number(res.Time);
          fetchRecentPosts();
        }
      }
    } else {
      posts = [];
    }
  };

  const fetchFirstLiveFeed = async () => {
    if (channel) {
      posts = [];
      const res = await fetchLivePosts(channel, page);
      stream = res.streamMeta;
      posts = res.posts.filter((e) => !e.IsDeleted);
      pagination = res.pagination;
      const time = await getLatestTimeStamp(channel);
      timestamp = Number(time.Time);
    } else {
      items = [];
    }
  };

  const nextPage = async () => {
    spinner = true;
    page += 1;
    const res = await fetchLivePosts(channel, page);
    let removeDeleted = res.posts.filter((e) => !e.IsDeleted);
    posts = posts.concat(removeDeleted);
    spinner = false;
  };

  const back = () => {
    const feedContainer = document.getElementsByClassName('feed-app')[0];
    feedContainer.scrollIntoView();
  };

  onDestroy(() => {
    clearInterval(interval);
  });
</script>

<style src="feedcontainer.scss">
</style>

{#if stream && posts}
  <div class="feed-container">
    <section class="feed-items">
      <header class="sub-title">{title || stream.Title}</header>
      {#each posts as post (post)}
        <FeedItem item={post} />
      {/each}
    </section>
    {#if spinner}
      <Spinner />
    {/if}
    {#if posts.length}
      <section class="navigation">
        {#if page + 1 < pagination.TotalPages}
          <button on:click={nextPage}>
            <Icon type="arrow_down" />
            Se flere</button>
        {/if}
        {#if posts.length > 10}
          <button on:click={back}>
            <Icon type="arrow_down" style="transform: rotate(180deg)" />
            Til toppen</button>
        {/if}
      </section>
    {:else}<span class="no-data">Ingen meldinger funnet</span>{/if}
  </div>
{/if}
